import { Component, Inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { DespachoService } from "../../../../services/despacho/despacho.service";
import { AppState } from "../../../../app.state";
import { select, Store } from "@ngrx/store";

import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatInputModule } from "@angular/material/input";
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { selectUsuario } from "../../../../states/usuario/selector";
import {
  Entregable,
  ITerminarEntregable,
} from "../../../../interfaces/despacho";
import { terminarEntregablesDespacho } from "../../../../states/despacho/actions";
import { ConfirmDialogComponent } from "../../../../confirm-dialog/confirm-dialog.component";
import { LoadingService } from "../../../../loading/loading.service";
import { firstValueFrom } from "rxjs";

@Component({
  selector: "app-terminar-entregable",
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatCheckboxModule,
  ],
  templateUrl: "./terminar-entregable.component.html",
  styleUrl: "./terminar-entregable.component.css",
})
export class TerminarEntregableComponent {
  private readonly stateUser: any = this.store.pipe(select(selectUsuario));
  motivoJustificacion = new FormControl("", [Validators.required]);

  public entregables: Entregable[] = [];
  selectAllChecked = false;

  constructor(
    public dialogRef: MatDialogRef<TerminarEntregableComponent>,
    public dialog: MatDialog,
    public despachoService: DespachoService,
    public loadingService: LoadingService,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private store: Store<AppState>
  ) {}

  async ngOnInit() {
    
    const enviadosEjecucion = await firstValueFrom(
      this.despachoService.listarEntregablesEnviadosAEjecucion(
        this.data.id_tema
      )
    );
    if (!enviadosEjecucion.error) {
      this.entregables = enviadosEjecucion.entregables.map(
        (entregable: Entregable) => {
          return { ...entregable, selected: false };
        }
      );
    }      
      
  }

  selectAll(checked: boolean): void {
    this.entregables.forEach((entregable: any) => {
      entregable.selected = checked;
    });
    this.selectAllChecked = checked;
  }

  updateSelectAllState(): void {
    const allSelected = this.entregables.every(
      (entregable: any) => entregable.selected
    );
    this.selectAllChecked = allSelected;
  }
  getEntregaablesChecked(): any {
    return this.entregables.filter((entregable: any) => entregable.selected);
  }
  async save() {
    this.loadingService.show();
    this.dialogRef.close();
    const user = structuredClone(this.stateUser.state().usuario);
    const entregables: ITerminarEntregable = {
      id_tema: this.data.id_tema,
      entregables: this.getEntregaablesChecked(),
      id_usuario: user.uid,
      usuario: user.nombre,
    };

    try {
      const terminarEntregable = await this.despachoService.terminarEntregables(
        entregables
      );
      if (!terminarEntregable.error) {
        this.store.dispatch(terminarEntregablesDespacho({ entregables }));
      }
    } catch (error) {
      this.loadingService.hide();
    }
  }
}
